<script lang='ts'>

    /* IMPORTS ----------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Link } from '@smatch/cassiopeia-web-components';

    // CONFIG
    import { PRIVACY_STATEMENT_URL, IMPRINT_URL, TERMS_URL } from 'src/config';

</script>


<!-- Imprint · Privacy Policy · Terms of Service · ©2024 smatch -->

<ul class = 's8-footer'>
    <li>
        <Link url = { IMPRINT_URL }>Imprint</Link>
    </li>
    <li>
        <Link url = { PRIVACY_STATEMENT_URL }>Privacy Policy</Link>
    </li>
    <li>
        <Link url = { TERMS_URL }>Terms of Service</Link>
    </li>
    <li>©{ new Date().getFullYear() } smatch</li>
</ul>


<style lang='postcss'>
    ul.s8-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
        height: 40px;

        li {
            color: rgba(39, 39, 17, 0.36);
            font-size: 9px;

            :global(a:hover) {
                text-decoration: underline;
            }
        }
    }
</style>